<template>
  <div>
    <p
      id="message"
      ref="editable"
      contenteditable
      v-on="listeners"
      class="hidden md:block desktop"
      v-if="vw >= 768"
    />
    <p
      v-else
      id="message"
      ref="editable"
      contenteditable
      v-on="listeners"
      class="block md:hidden mobile"
    />
  </div>
</template>

<script>
export default {
  name: "Editable",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  computed: {
    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },
    vw() {
      return Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
    }
  },
  watch: {
    value: function(val) {
      if (val != this.$refs.editable.innerHTML) {
        this.$refs.editable.innerHTML = val;
      }
    }
  },
  mounted() {
    this.$refs.editable.innerHTML = this.value;
  },
  methods: {
    onInput(e) {
      this.$emit("input", e.target.innerHTML);
    }
  }
};
</script>

<style lang="scss" scoped>
p:focus {
  outline: none !important;
}
[contentEditable="true"]:empty:not(:focus):before {
  content: "Introduzca un comentario. Puede escribir @ para mencionar a alguien.";
  color: grey;
}
[contentEditable="true"].mobile:empty:not(:focus):before {
  content: "Introduzca un comentario";
  color: grey;
}
</style>
